export default __webpack_public_path__ + "static/media/ohio.c1d85151.jpg";